import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './hooks/useTheme';
import { ApplicationProvider, AuthProvider, MemberProvider, PublicConfigProvider, ContributionProvider, ProfileProvider } from './context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <PublicConfigProvider>
        <AuthProvider>
          <ProfileProvider>
          <ApplicationProvider>
            <MemberProvider>
                <ContributionProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
                </ContributionProvider>
            </MemberProvider>
          </ApplicationProvider>
          </ProfileProvider>
        </AuthProvider>
      </PublicConfigProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
